import config from 'cfg';
import _ from 'lodash';
import prodConfig from '../../../config/prod.json';

export const smwidget2image = url => {
    const webshotIsLocal = config.apis.webshot.indexOf('127.0.0.1') !== -1;
    if (!webshotIsLocal) url = url.replace('http://127.0.0.1:3003', prodConfig.widgets.url);

    var params = {
        quality: 100,
        url,
        captureSelector: '.sm-wdp',
        whiteBg: false,
        windowWidth: 800,
        renderDelay: 200,
        browser: config.webshotBrowser,
        streamType: 'png',
        userAgent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X) AppleWebKit/534.34 (KHTML, like Gecko) PhantomJS/2.1.1 (development) Safari/534.34',
    };
    var convertUrl = config.apis.webshot + '/api/convert';
    return fetch(convertUrl, {
        method: 'post',
        body: JSON.stringify(params),
        headers: { 'Content-Type': 'application/json' },
    }).then(response => response.json());
};

export const htmlwidget2image = url => {
    const webshotIsLocal = config.apis.webshot.indexOf('127.0.0.1') !== -1;
    if (!webshotIsLocal) url = url.replace('http://127.0.0.1:3003', prodConfig.widgets.url);

    var params = {
        quality: 100,
        url,
        captureSelector: '.wdp',
        whiteBg: false,
        browser: config.webshotBrowser,
        windowWidth: 800,
        renderDelay: 2000,
        streamType: 'png',
        userAgent:
            'Mozilla/5.0 (Macintosh; Intel Mac OS X) AppleWebKit/534.34 (KHTML, like Gecko) PhantomJS/2.1.1 (development) Safari/534.34',
    };
    var convertUrl = config.apis.webshot + '/api/convert';
    return fetch(convertUrl, {
        method: 'post',
        body: JSON.stringify(params),
        headers: { 'Content-Type': 'application/json' },
    }).then(response => response.json());
};

export const widget2image = (widget, url) => {
    return widget.spec.social ? smwidget2image(url) : htmlwidget2image(url);
};

export const widget2video = (widget, url, videoLength) => {
    videoLength = videoLength || widget.spec.videoLength || 30;
    const generatorIsLocal = config.apis.html2video.indexOf('127.0.0.1') !== -1;
    if (!generatorIsLocal) url = url.replace('http://127.0.0.1:3003', prodConfig.widgets.url);
    var generateUrl = `${
        config.apis.html2video
    }/api/generate?videoLength=${videoLength}&animationSpeedModifier=0.5&url=${encodeURIComponent(url)}`;

    return fetch(generateUrl, {
        method: 'get',
    }).then(r => r.json());
};

export const browserDownloadWidget2image = (widget, url) => {
    return widget2image(widget, url).then(resp => {
        // var a = document.createElement('a');
        // a.href = resp.url;
        // a.setAttribute('target', '__blank');
        // a.setAttribute('download', widget.spec.id + '.png');
        // a.download = widget.spec.id + '.png';
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        // a.remove();

        forceDownload(resp.url, `${widget.name}.png`);
        return resp;
    });
};

export const browserDownloadWidget2video = (widget, url, videoLength) => {
    return widget2video(widget, url, videoLength).then(r => {
        return new Promise((resolve, reject) => {
            const checkStatusInterval = setInterval(() => {
                fetch(`${config.apis.html2video}${r.location}`)
                    .then(r => r.json())
                    .then(queue => {
                        if (queue.status === 'done') {
                            clearInterval(checkStatusInterval);

                            forceDownload(queue.location, widget.spec.id + '.mp4');

                            var a = document.createElement('a');
                            a.href = queue.location;
                            a.setAttribute('target', '__blank');
                            a.download = widget.spec.id + '.mp4';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            a.remove();
                            resolve(queue.location);
                        } else if (queue.status === 'failed') {
                            clearInterval(checkStatusInterval);
                            reject();
                        }
                    });
            }, 10000);
        });
    });
};

export const widget2videoLink = (url, videoLength) => {
    return widget2video(null, url, videoLength).then(r => {
        return new Promise((resolve, reject) => {
            const checkStatusInterval = setInterval(() => {
                fetch(`${config.apis.html2video}${r.location}`)
                    .then(r => r.json())
                    .then(queue => {
                        if (queue.status === 'done') {
                            clearInterval(checkStatusInterval);
                            resolve({ url: queue.location, video: true, picture: queue.pictureUrl });
                        } else if (queue.status === 'failed') {
                            clearInterval(checkStatusInterval);
                            reject();
                        }
                    });
            }, 10000);
        });
    });
};

function forceDownload(url, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    };
    xhr.send();
}

export const browserDownloadSMWidget2image = url => {
    return smwidget2image(url).then(resp => {
        forceDownload(resp.url, 'widget.png');
        return resp;
    });
};

export const embedWPCode = (method, user, commonParams, params) => {};
export const embedCode = (method, name, user, common = {}, params = {}) => {
    var commonParams = {
        'data-load': method,
        // user related
        'data-client': user.client,
        'data-user': user.username,
        'data-token': user.accessToken,
        'data-ga': user.defaultProps.GA,
        // core params
        'data-lang': common.lang,
        'data-theme': common.theme,
    };
    var pp = _.clone(params);

    Reflect.deleteProperty(pp, 'data-theme');
    Reflect.deleteProperty(pp, 'data-debug');

    params = _.extend({}, pp, commonParams);

    var paramsStr = _.chain(params)
        .toPairs()
        .reduce((memo, p) => (p[1] ? `${memo} ${p[0]}=${JSON.stringify(p[1])}` : memo), '')
        .value();
    return `<rlz-widget data-name="${name}" ${paramsStr} />`;
};

export const embedInjectorCode = () => {
    return `<script type="text/javascript" src="${config.WDPLinkr.injector()}" crossorigin async></script>`;
};



/** WEBPACK FOOTER **
 ** ../src/widgets/actions/widgets.js
 **/